var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.578,
    height: 24.954,
    viewBox: "0 0 22.578 24.954",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_satelite_4254679",
    transform: "translate(-1.5 -1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M15.571,10.654l.015-.01,1.188-1.188h0a1.763,1.763,0,0,0,.768.173A1.782,1.782,0,1,0,15.76,7.847a1.763,1.763,0,0,0,.179.765h0L14.751,9.8l-.01.015L7.59,2.674a.594.594,0,0,0-.84,0A11.3,11.3,0,0,0,5,16.352L2.819,25.078H2.094a.594.594,0,1,0,0,1.188H11.6a.594.594,0,1,0,0-1.188H9.818V20.807a11.273,11.273,0,0,0,12.9-2.167.594.594,0,0,0,0-.84Zm1.971-3.4a.594.594,0,1,1-.594.594A.594.594,0,0,1,17.542,7.253ZM8.63,25.078H4.043L5.9,17.671a11.681,11.681,0,0,0,.856.968A11.32,11.32,0,0,0,8.63,20.149ZM7.59,17.8A10.116,10.116,0,0,1,7.182,3.946l14.26,14.26A10.114,10.114,0,0,1,7.59,17.8Z",
    transform: "translate(-1.5 -1.312)",
    fill: "#0077b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M18.065,7.659a.594.594,0,1,0,1.188,0A4.159,4.159,0,0,0,15.094,3.5a.594.594,0,1,0,0,1.188,2.971,2.971,0,0,1,2.971,2.971Z",
    transform: "translate(0.948 -1.123)",
    fill: "#db5f28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M15.094,1.5a.594.594,0,0,0,0,1.188,5.353,5.353,0,0,1,5.347,5.347.594.594,0,0,0,1.188,0A6.543,6.543,0,0,0,15.094,1.5Z",
    transform: "translate(0.948 -1.5)",
    fill: "#db5f28"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDth);
export default __webpack_public_path__ + "static/media/dth.5e18e2ef50ebaa9af0a6551808c3a126.svg";
export { ForwardRef as ReactComponent };